module.exports = __webpack_public_path__ + "static/FL20_Prices_Realized-063d328b367a28f4be6c0521a02c95ff.pdf";